module.exports = __webpack_public_path__ + "components/nearby/static/nearby-location--blue-bf9a1cd4aa131975e4c62f649ad3833c.svg";